<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12" class="mt-1">
        <div class="dispatch-table">
          <b-card header="TRUCKER'S DASHBOARD - INBOUND">
            <div class="table-responsive" style="overflow: auto">
              <table class="table-bordered col-md-12">
                <tr v-for="(data, columnIndex) in rawData" :key="columnIndex">
                  <td nowrap v-for="(columnData, index) in data" :key="index">
                    <center>
                      <p
                        :class="
                          columnData == 1
                            ? 'activeStatus icon-check active_icon'
                            : ''
                        "
                      >
                        {{
                          columnData == 1 || columnData == 0 ? "" : columnData
                        }}
                      </p>
                    </center>
                  </td>
                </tr>
              </table>
            </div>
            <b-modal
              centered
              title="FILTER DATA"
              id="modal-sm"
              size="sm"
              v-model="onviewModal"
              @ok="onfiltersearch"
            >
              <div class="px-5">
                <b-form-group>
                  <label for="remarks">From</label>
                  <input class="form-control" type="date" v-model="arrival" />
                  <!-- <datetime type="date" week-start="7" class="form-control" v-model="startdate" value-zone="local" zone="local"></datetime> -->
                </b-form-group>
                <b-form-group>
                  <label for="remarks">To</label>
                  <input class="form-control" type="date" v-model="departure" />
                  <!-- <datetime type="date" week-start="7" class="form-control" v-model="endDate" value-zone="local" zone="local"></datetime> -->
                </b-form-group>
              </div>
            </b-modal>
          </b-card>
          <b-card header="TRUCKER'S DASHBOARD - OUTBOUND">
            <div class="table-responsive" style="overflow: auto">
              <table class="table-bordered col-md-12">
                <tr
                  v-for="(data, columnIndex) in rawDataOut"
                  :key="columnIndex"
                >
                  <td nowrap v-for="(columnData, index) in data" :key="index">
                    <center>
                      <p
                        :class="
                          columnData == 1
                            ? 'activeStatus icon-check active_icon'
                            : ''
                        "
                      >
                        {{
                          columnData == 1 || columnData == 0 ? "" : columnData
                        }}
                      </p>
                    </center>
                  </td>
                </tr>
              </table>
            </div>
            <b-modal
              centered
              title="FILTER DATA"
              id="modal-sm"
              size="sm"
              v-model="onviewModal"
              @ok="onfiltersearch"
            >
              <div class="px-5">
                <b-form-group>
                  <label for="remarks">From</label>
                  <input class="form-control" type="date" v-model="arrival" />
                  <!-- <datetime type="date" week-start="7" class="form-control" v-model="startdate" value-zone="local" zone="local"></datetime> -->
                </b-form-group>
                <b-form-group>
                  <label for="remarks">To</label>
                  <input class="form-control" type="date" v-model="departure" />
                  <!-- <datetime type="date" week-start="7" class="form-control" v-model="endDate" value-zone="local" zone="local"></datetime> -->
                </b-form-group>
              </div>
            </b-modal>
          </b-card>
          <br />
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
// import api from "../../services/api";
// import JSONToCSVConvertor from "./../../services/JSONToCSVConvertor.js";
import axios from "axios";
import moment from "moment";
export default {
  data: function () {
    return {
      timer: "",
      progressCap: null,
      deleteModal: false,
      selectedItem: {},
      selectedItemLabel: "",
      selectedfile: null,
      rawData: [],
      rawDataOut: [],
      perPage: this.$store.getters.perPage,
      total: 0,
      currentPage: 1,
      isBusy: false,
      filter: null,
      isstart: [],
      isfinish: [],
      transdescription: [],
      transmasterid: [],
      remarkstrans: [],
      dwellday: null,
      dwellhour: null,
      dwellmin: null,
      sortno: [],
      trucker: [
        {
          fleetregistryId: 1,
          parkinglane: "park",
          lanetype: "test",
          branfleetownerId: 1,
          plateno: "123test",
          arrivaldatetime: "11-11-2020 07:00 AM",
          transmasterid: 1,
          transdescription: "testdesc",
          isstart: 1,
          isfinish: 1,
          Dwell_Day: "1",
          Dwell_Hour: "24",
          Dwell_Minute: "300",
          Remarks: "test",
          sortno: 1,
        },
      ],

      truckerout: [
        {
          fleetregistryId: 1,
          parkinglane: "park",
          lanetype: "test",
          branfleetownerId: 1,
          plateno: "123test",
          arrivaldatetime: "11-11-2020 07:00 AM",
          transmasterid: 1,
          transdescription: "testdesc",
          isstart: 1,
          isfinish: 1,
          Dwell_Day: "1",
          Dwell_Hour: "24",
          Dwell_Minute: "300",
          Remarks: "test",
          sortno: 1,
        },
      ],

      fleetlist: [],
      List: [],
      fleet: [],
      l: [],
      search: null,
      onviewModal: false,
      arrival: moment(new Date()).format("YYYY-MM-DD"),
      departure: moment(new Date()).format("YYYY-MM-DD"),

      fields: [
        {
          key: "parkinglane",
          label: "Lane No.",
          sortable: true,
        },
        {
          key: "lanetype",
          label: "Trans Type",
          sortable: true,
        },
        {
          key: "branfleetownerId",
          label: "Trucker",
          sortable: false,
        },

        {
          key: "plateno",
          label: "Plate No.",
          sortable: true,
        },
        {
          key: "arrivaldatetime",
          label: "ADT",
          formatter: "DateConvertFooter",
        },

        {
          key: "DwellTime",
          label: "DD: HH: MM",
        },
        {
          key: "Remarks",
          label: "Remarks",
        },
      ],
    };
  },

  computed: {},

  methods: {
    onfilter() {
      this.onviewModal = true;
    },

    onfiltersearch() {
      this.isBusy = true;
      var self = this;
      self.$store.commit("setLoading", true);
      axios
        .get(
          this.$store.state.IFMSURLlocal +
            "get-fleet-registry-arrival?brancode=" +
            self.$store.state.selectedWarehouse +
            "&arrival=" +
            self.arrival +
            "&arrivalend=" +
            self.departure
        )
        .then((resp) => {
          self.fleet = resp.data;
          self.total = resp.data.total;
          console.log(this.arrival);
          self.$store.commit("setLoading", false);
          self.isBusy = false;
        })
        .catch((error) => {
          // Here we could override the busy state, setting isBusy to false
          self.isBusy = false;
          self.$store.commit("setLoading", false);
          // Returning an empty array, allows table to correctly handle busy state in case of error
          return [];
        });
    },

    DateConvertFooter(date) {
      if (date !== null) {
        var newDate = date;
        newDate =
          newDate[1] + "-" + newDate[2].substring(0, 2) + "-" + newDate[0];
        return moment(date).format("MM-DD-YYYY, h:mm a");
      }
    },

    TimeConvertFooter(date) {
      if (date !== null) {
        var newDate = date;
        newDate =
          newDate[1] + "-" + newDate[2].substring(0, 2) + "-" + newDate[0];
        return moment(date).format("LT");
      }
    },

    getFleetRegistry() {
      // Here we don't set isBusy prop, so busy state will be handled by table itself
      this.isBusy = true;
      var self = this;
      self.$store.commit("setLoading", true);
      axios
        .get(
          this.$store.state.IFMSURLlocal +
            "TruckerDashboard?site=" +
            self.$store.state.selectedWarehouse +
            "&regtype=IBD"
        )
        .then((resp) => {
          self.trucker = [];
          resp.data.forEach((resp) => {
            self.dwellday = null;
            self.dwellhour = null;
            self.dwellmin = null;
            self.isstart = [];
            self.isfinish = [];
            self.transdescription = [];
            self.transmasterid = [];
            self.remarkstrans = [];
            self.sortno = [];

            resp.truckdash.forEach((position) => {
              self.isstart.push(position.isstart);
              self.isfinish.push(position.isfinish);
              self.transdescription.push(position.transdescription);
              self.transmasterid.push(position.transmasterid);
              self.sortno.push(position.sortno);
              //  self.remarkstrans.push(position.Remarks);
              // self.dwellday = position.Dwell_Day;
              // self.dwellhour = position.Dwell_Hour;
              // self.dwellmin = position.Dwell_Minute;
            });

            self.trucker.push({
              fleetregistryId: resp.fleetregistryid,
              parkinglane: resp.parkinglane,
              lanetype: resp.lanetype,
              branfleetownerId: resp.branfleetownerId,
              plateno: resp.plateno,
              arrivaldatetime: resp.arrivaldatetime,
              transdescription: self.transdescription,
              transmasterid: self.transmasterid,
              isstart: self.isstart,
              isfinish: self.isfinish,
              startindex: self.transmasterid[0],
              endindex: self.transmasterid[self.transmasterid.length - 1],
              Dwell_Day: resp.Dwell_Day,
              Dwell_Hour: resp.Dwell_Hour,
              Dwell_Minute: resp.Dwell_Minutes,
              Remarks: resp.Remarks,
              sortno: self.sortno,
            });
          });

          console.log(self.trucker);
          //  self.fleetlist = self.trucker.FleetList;

          // self.total = resp.data.total;
          // console.log(resp.data);
          self.$store.commit("setLoading", false);
          this.generateReport();
          self.isBusy = false;
        })
        .catch((error) => {
          // Here we could override the busy state, setting isBusy to false
          self.isBusy = false;
          self.$store.commit("setLoading", false);
          // Returning an empty array, allows table to correctly handle busy state in case of error
          return [];
        });
      // setTimeout(this.getFleetRegistry(), 60000);
    },

    getFleetRegistryOut() {
      // Here we don't set isBusy prop, so busy state will be handled by table itself
      this.isBusy = true;
      var self = this;
      self.$store.commit("setLoading", true);
      axios
        .get(
          this.$store.state.IFMSURLlocal +
            "TruckerDashboard?site=" +
            self.$store.state.selectedWarehouse +
            "&regtype=OBD"
        )
        .then((resp) => {
          self.truckerout = [];
          resp.data.forEach((resp) => {
            // self.dwellday = null;
            // self.dwellhour = null;
            // self.dwellmin = null;
            self.isstart = [];
            self.isfinish = [];
            self.transdescription = [];
            self.transmasterid = [];
            self.remarkstrans = [];
            self.sortno = [];

            resp.truckdash.forEach((position) => {
              self.isstart.push(position.isstart);
              self.isfinish.push(position.isfinish);
              self.transdescription.push(position.transdescription);
              self.transmasterid.push(position.transmasterid);
              self.sortno.push(position.sortno);
            });

            self.truckerout.push({
              fleetregistryId: resp.fleetregistryid,
              parkinglane: resp.parkinglane,
              lanetype: resp.lanetype,
              branfleetownerId: resp.branfleetownerId,
              plateno: resp.plateno,
              arrivaldatetime: resp.arrivaldatetime,
              transdescription: self.transdescription,
              transmasterid: self.transmasterid,
              isstart: self.isstart,
              isfinish: self.isfinish,
              startindex: self.transmasterid[0],
              endindex: self.transmasterid[self.transmasterid.length - 1],
              Dwell_Day: resp.Dwell_Day,
              Dwell_Hour: resp.Dwell_Hour,
              Dwell_Minute: resp.Dwell_Minutes,
              Remarks: resp.Remarks,
              sortno: self.sortno,
            });
          });

          console.log(self.truckerout);
          self.$store.commit("setLoading", false);
          this.generateReportOut();
          self.isBusy = false;
        })
        .catch((error) => {
          // Here we could override the busy state, setting isBusy to false
          self.isBusy = false;
          self.$store.commit("setLoading", false);
          // Returning an empty array, allows table to correctly handle busy state in case of error
          return [];
        });
      // setTimeout(this.getFleetRegistry(), 60000);
    },

    cancelAutoUpdate() {
      clearInterval(this.timer);
    },

    getFleetList() {
      // Here we don't set isBusy prop, so busy state will be handled by table itself
      this.isBusy = true;
      var self = this;
      self.$store.commit("setLoading", true);
      axios
        .get(
          this.$store.state.IFMSURLlocal +
            "fleetlist?branch=" +
            self.$store.state.selectedWarehouse
        )
        .then((resp) => {
          self.List = resp.data;
          console.log(self.List.FleetList);
          //  self.fleetlist = self.trucker.FleetList;

          // self.total = resp.data.total;
          // console.log(resp.data);
          self.$store.commit("setLoading", false);
          self.isBusy = false;
        })
        .catch((error) => {
          // Here we could override the busy state, setting isBusy to false
          self.isBusy = false;
          self.$store.commit("setLoading", false);
          // Returning an empty array, allows table to correctly handle busy state in case of error
          return [];
        });
    },

    generateReport() {
      const vm = this;
      axios
        .post(this.$store.state.IFMSURLlocal + "truck/truckDash", vm.trucker)
        .then((resp) => {
          vm.rawData = resp.data;
          console.log(resp.data);
        })
        .catch((err) => {
          alert("error!");
        });
    },

    generateReportOut() {
      const vm = this;
      axios
        .post(
          this.$store.state.IFMSURLlocal + "truck/truckDashOut",
          vm.truckerout
        )
        .then((resp) => {
          vm.rawDataOut = resp.data;
          console.log(resp.data);
        })
        .catch((err) => {
          alert("error!");
        });
    },
  },

  beforeDestroy() {
    clearInterval(this.timer);
  },

  created: function () {
    alert("Hello");
    var curr = new Date();
    var first = curr.getDate() - curr.getDay();
    var last = first + 6;
    var firstday = new Date(curr.setDate(first)).toString();
    var lastday = new Date(curr.setDate(curr.getDate() + 6)).toString();
    this.arrival = moment(firstday).format("YYYY-MM-DD");
    this.departure = moment(lastday).format("YYYY-MM-DD");
    this.getFleetRegistry();
    this.getFleetRegistryOut();
    this.timer = setInterval(this.getFleetRegistry, 20000);
  },

  watch: {
    trucker() {
      var i;
      var j;
      for (i = 0; i < this.trucker.length; i++) {
        this.fleetlist[i] = this.trucker[i].truckdash;
        for (j = 0; j < this.fleetlist[i].length; j++) {
          this.l.push(this.fleetlist[i][j].transdescription);

          // console.log('fleet', this.fleetlist);
        }
        //    console.log('fleetlist', this.l);
      }
    },
  },
};
</script>